import * as constants from './constants'

export const addCreditCard = (temporaryToken, nameOnCard) => ({
    type: constants.ADD_CREDIT_CARD,
    temporaryToken,
    nameOnCard,
})
